import React, { useEffect } from "react";
import Like from "./filtros/Like";
import Number from "./filtros/Number";
import Fecha from "./filtros/Fecha";
import SelectF from "./filtros/Select";
import CheckboxF from "./filtros/Checkbox";
import RadioF from "./filtros/RadioButton";
import AutocompletarF from "./filtros/AutocompletarF";
import InputBuscador from "./filtros/InputBuscador/InputBuscador";
import AutocompletarConFetch from "./filtros/AutocompletarConFetch";

const SwitchFiltros = (props) => {
  useEffect(() => {
    const abortController = new AbortController();
    const { setFiltrosAAplicar, id_a, filtrosAAplicar } = props;

    setFiltrosAAplicar((prevState) => {
      return {
        ...prevState,
        [id_a]: props.default ?? filtrosAAplicar[id_a],
      };
    });

    return () => {
      abortController.abort();
    };
  }, [props.default]);

  const { componente } = props;
  const Componente = (() => {
    switch (componente) {
      case "like":
        return <Like {...props} />;
      case "number":
        return <Number {...props} />;
      case "fecha":
        return <Fecha {...props} />;
      case "fecha_simple":
        return <Fecha {...props} />;
      case "select":
        return <SelectF {...props} />;
      case "enum":
        return <SelectF {...props} />;
      case "checkbox":
        return <CheckboxF {...props} />;
      case "radio":
        return <RadioF {...props} />;
      case "autocompletar":
        return <AutocompletarF {...props} />;
      case "autocompletar_fetch":
        return <AutocompletarConFetch {...props} />;
      case "filtro_buscador":
        return <InputBuscador {...props} cab={props} />;
      case "grupo_filtros":
        // el grupo filtros desagrupa los filtros por backend. Esta funcion no aplica.
        return props.sc_hijos.map((h) => {
          return (
            <SwitchFiltros
              {...h}
              key={h.id_a}
              filtrosAAplicar={props.filtrosAAplicar}
              setFiltrosAAplicar={props.setFiltrosAAplicar}
              requeridos={props.requeridos}
              setRequeridos={props.setRequeridos}
              error={props.error}
              setError={props.setError}
              context={props.ListadoContext}
            />
          );
        });
      default:
        return <></>;
    }
  })();

  if (componente === "hidden") return <></>;
  if (componente === "grupo_filtros") return <></>;

  function calcGridColumn(cab) {
    const { grid_span, grid_area } = cab;

    if (grid_area && grid_area !== "") {
      return {
        gridArea: grid_area,
      };
    }

    if ((!grid_area || grid_area === "") && grid_span && grid_span !== "") {
      return {
        gridColumn: grid_span,
      };
    }

    return { gridColumn: "span 6 / auto" };
  }

  const grids = calcGridColumn(props);

  return (
    <div
      id={props.id_a}
      className="filtro_grid_int"
      style={Object.assign(
        {
          alignSelf:
            componente in ["like", "autocompletar", "filtro_buscador"]
              ? "center"
              : "start",
        },
        grids
      )}
    >
      {Componente}
    </div>
  );
};

export default SwitchFiltros;
